import { ResourceHelperService } from "../resource-helper.service";

/**
 * A dataservice that performs operations on charge account entries against the backend charge-account service
 */
export class ChargeAccountService {
  public chargeAccountsResource: InterACT.Interfaces.IResource<InterACT.Interfaces.ChargeAccounts.ChargeAccountsResponse>;
  public chargeAccountResource: InterACT.Interfaces.IResource<InterACT.Interfaces.ChargeAccounts.ChargeAccountResponse>;
  public chargeAccountsSummationResource: InterACT.Interfaces.IResource<InterACT.Interfaces.Journeys.SummationResponse>;
  constructor($resource, private resourceHelperService: ResourceHelperService) {
    this.chargeAccountsResource = $resource(
      'api/charge-accounts',
      undefined,
      { update: { method: 'PUT' } });

    this.chargeAccountResource = $resource(
      'api/charge-accounts/:id',
      undefined,
      { update: { method: 'PUT' } });

    this.chargeAccountsSummationResource = $resource(
      'api/charge-accounts/summation',
      undefined);
  }


  /**
   * Retrieves a summation of Charge Account
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param queryString The query to search for Charge Account
   * @param grouping used to group and sum the results
   *
   * @returns A promise of a charge account summation
   */
  public getChargeAccountSummation(searchText: string, grouping: string) {
    const options = {
      q: searchText,
      grouping: grouping
    }
    return this.chargeAccountsSummationResource.get(options).$promise;
  }

  /**
   * Retrieves list of Charge Account
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param queryString The query to search for Charge Account
   * @param returnMeta a boolean value that indicates if the emta data should be returned with the charge accounts or not
   *
   * @returns A promise of a ChargeAccountsResponse
   */
  public getChargeAccounts(page: number, perPageCount: number, searchText: string, returnMeta?: boolean) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, searchText);
    return this.chargeAccountsResource.get(options).$promise.then((response) => {
      return returnMeta ? response : response.chargeAccounts;
    });
  }

  /**
 * Retrieves a single charge account for the supplied id
 *
 * @param id The id of the charge account to retrieve
 *
 * @returns A promise of a ChargeAccountResponse
 */
  public getChargeAccount(id: string) {
    return this.chargeAccountResource.get({ id: id }).$promise;
  }

  /**
   * Sends a charge account for processing in the backend server application
   *
   * @param chargeAccount An object representation of a charge account
   *
   * @returns A promise of a ChargeAccountsResponse
   */
  public createChargeAccount(data: InterACT.Interfaces.ChargeAccounts.ChargeAccount) {
    return this.chargeAccountsResource.save(data).$promise;
  }

  /**
   * Function to update a record from chargeAccount service
   *
   * @param id The id of the charge account to be updated
   * @param data The chargeAccount data object to be sent in a PUT operation to the server
   *
   * @returns A http promise object
   */
  public updateChargeAccount(id: string, data: InterACT.Interfaces.ChargeAccounts.ChargeAccount) {
    return (<any>this.chargeAccountResource).update({ id: id }, data).$promise;
  }
}